module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216.3 144.2"><path class="st10" fill="#0077be" stroke="#000" stroke-width=".25" d="M.1.1h216v144H.1z"/><path class="st5" fill="#fff" stroke="#000" stroke-width=".25" d="M80.1 16.1h136.1v16H80.1zM80.1 48.1h136.1v16H80.1zM.1 112.1h216v16H.1z"/><path class="st5" fill="#fff" stroke="#000" stroke-width=".25" d="M47.9 80.1h168.2v16H.1v-16h31.8v-32H.1v-16h31.8V.1h16v32h32.2v16H47.9z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/flag/flg1.svg
// module id = 518
// module chunks = 1